import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import styles from "./ContactSection.scss";
import { HashTag } from "../../../../models";
import AdReportForm from "../../AdDetailsPageWeb/AdReportForm";
import history, { navigateToLogin } from "../../../../history";
import { selectLoadedUser } from "../../../../routes/Auth/auth.ducks";
import ContactHeader from "./ContactHeader";
import PhoneButtonSection from "./PhoneButtonSection";
import ContacSellertInfo from "./ContacSellertInfo";
import ReactGA from "react-ga4";
import { creatorInterface } from "../../../../typings/interfaces";
import useHrPageName from "../../../../utils/useHrPageName";

interface ContactSectionProps {
  adId: string;
  category: string;
  seller: creatorInterface;
  externalUrl: string;
  hasPhones: boolean;
  onCallPhoneClick: () => void;
  onChatClick: () => void;
  disabled: boolean;
  adTitle?: string;
}

const ContactSection: React.FC<ContactSectionProps> = props => {
  const {
    category,
    seller,
    externalUrl,
    hasPhones,
    onCallPhoneClick,
    onChatClick,
    disabled,
    adId,
    adTitle,
  } = props;

  const [isReportVisible, setIsReportVisible] = useState(false),
    user = useSelector(selectLoadedUser);

    const hrPageName = useHrPageName(category);

  useEffect(() => {
    const adReport = history.location.hash === HashTag.adReport;

    if (adReport) {
      setIsReportVisible(true);
    }

    if (adReport) history.replace(history.location.pathname);
  }, []);

  const handleReportOpen = () => {
    ReactGA.event({
      category: "Detalji oglasa",
      action: "Click",
      label: `Prijavi oglas - ${hrPageName}`
    });

    if (user) {
      setIsReportVisible(true);
    } else {
      navigateToLogin(window.location.href + HashTag.adReport);
    }
  };

  const handleReportClose = () => {
    setIsReportVisible(false);
  };

  const handleReportSubmit = (
    data: { description: string; reason: number },
    onSubmit: Function
  ) => {
    const { adId } = props;

    const reportData = {
      ...data,
      adId
    };

    onSubmit(reportData, status => {
      if (status) {
        setIsReportVisible(false);
      }
    });
  };

  return (
    <div className={`${styles.container} ${disabled ? styles.disabled : ""}`}>
      <div className={styles.sellerInfo}>
        <ContactHeader
          userAvatar={seller.avatar}
          seller={seller}
          category={category}
          adId={adId}
        />
        <ContacSellertInfo seller={seller} />
      </div>
      <div className={styles.buttonInfo}>
        <PhoneButtonSection
          seller={seller}
          hasPhones={hasPhones}
          onCallPhoneClick={onCallPhoneClick}
          onReportOpen={handleReportOpen}
          onChatClick={onChatClick}
          externalUrl={externalUrl}
          adId={adId}
          adTitle={adTitle}
          user={user}
        />
        <AdReportForm
          visible={isReportVisible}
          onCancel={handleReportClose}
          onCreate={handleReportSubmit}
        />
      </div>
    </div>
  );
}

ContactSection.defaultProps = {
  adId: "",
  category: "",
  seller: {
    username: null
  },
  hasPhones: false,
  onCallPhoneClick: () => null,
  disabled: false,
};

export default ContactSection;



// WEBPACK FOOTER //
// ./src/containers/AdDetailsPage/AdDetailsPageMobile/ContactSection/index.tsx